export default __webpack_public_path__ + "static/media/ic_schoolSide.ed438549aea4d59eae37a3c2c9003df1.svg";